(function() {
    'use strict';

    angular.module('remitEventsApp').service('HelpersService', function($document, $sce, $rootScope) {
        var currentSetPrevFiltersState = null;

        /* jshint ignore:start */
        this.applyScope = function(scope) {
            // eslint-disable-next-line angular/no-private-call
            if (!scope.$$phase && scope.$root && !scope.$root.$$phase) {
                scope.$apply();
            }
        };
        /* jshint ignore:end */

        this.setPreviusFilters = function(stateName, data) {
            $rootScope.filters = {};
            $rootScope.filters[stateName] = data;

            currentSetPrevFiltersState = 2;
        };

        this.loadPreviusFilters = function(stateName) {
            return $rootScope.filters ? $rootScope.filters[stateName] : {};
        };

        this.clearPrevData = function() {
            if (currentSetPrevFiltersState === 0) {
                currentSetPrevFiltersState = null;
                $rootScope.filters = {};
            }

            if (currentSetPrevFiltersState) {
                currentSetPrevFiltersState--;
            }
        };

        this.getPaginationConfig = function() {
            return {
                totalElements: 0,
                page: 0,
                size: 20
            };
        };

        this.findElement = function(element) {
            var domElement = angular.element($document[0].querySelector(element));

            var that = {
                element: domElement[0],
                width: function(value) {
                    if (value) {
                        domElement[0].style.width = _.isNumber(value) ? value + 'px' : value;

                        return that;
                    }

                    return domElement[0] ? domElement[0].clientWidth : 0;
                },
                height: function(value) {
                    if (value) {
                        domElement[0].style.height = _.isNumber(value) ? value + 'px' : value;

                        return that;
                    }

                    return domElement[0] ? domElement[0].clientHeight : 0;
                },
                position: function() {
                    var leftPosition = domElement[0].offsetWidth - parseInt(domElement[0].style.width);

                    return {
                        left: leftPosition
                    };
                },
                scrollLeft: function(value) {
                    if (domElement[0]) {
                        domElement[0].scrollLeft = value;
                    }

                    return that;
                },
                css: function(value) {
                    domElement.css(value);

                    return that;
                },
                addClass: function(value) {
                    domElement.addClass(value);

                    return that;
                },
                removeClass: function(value) {
                    domElement.removeClass(value);

                    return that;
                },
                removeAttr: function(value) {
                    domElement.removeAttr(value);

                    return that;
                }
            };

            return that;
        };

        this.normalize = function(str) {
            str = str || '';
            return str
                .toLowerCase()
                .replace(/\\s/g, '')
                .replace(/[ą]/g, 'azzz')
                .replace(/[ć]/g, 'czzz')
                .replace(/[ę]/g, 'ezzz')
                .replace(/[ł]/g, 'lzzz')
                .replace(/[ń]/g, 'nzzz')
                .replace(/[ó]/g, 'ozzz')
                .replace(/[ś]/g, 'szzz')
                .replace(/[żź]/g, 'zzz')
                .replace(/\\W/g, '');
        };

        this.objectIsEmpty = function(obj) {
            if (!obj) return true;

            if (obj.length > 0) return false;
            if (obj.length === 0) return true;

            for (var key in obj) {
                if (hasOwnProperty.call(obj, key)) return false;
            }

            return true;
        };

        this.returnAsTrustedHTML = function(value) {
            return $sce.trustAsHtml(value);
        };

        this.copyObjectArray = function(objArr) {
            if (objArr) {
                return angular.fromJson(angular.toJson(objArr));
            }

            return {};
        };
    });
})();
